import React,{useState} from 'react'



const PoliticalOfficerComp = (props) => {
    console.log(props.list);
    return (
        <div>
            <ul>
                <li className="flex-center">
                    <div className="flex-1 flex-center placeholder">Name</div>
                    <div className="flex-1 flex-center placeholder">Title</div>
                    <div className="flex-1 flex-center placeholder">Agency</div>
                    <span className="btn-icon" onClick={props.onAdd}><img className="icon-small" src="img/icon/plus_black.svg" alt="icon pretrade"/></span>
                </li>
                {props.list.map((item,idx)=>(
                <li key={idx} className="flex">
                    <div className="flex-1"><input className="full-width" type="text" name="name" maxLength="200" value={item.name} onChange={e=>props.onChange(e,idx)}/></div>
                    <div className="flex-1"><input className="full-width" type="text" name="title" maxLength="200" value={item.title} onChange={e=>props.onChange(e,idx)}/></div>
                    <div className="flex-1"><input className="full-width" type="text" name="agency" maxLength="200" value={item.agency} onChange={e=>props.onChange(e,idx)}/></div>
                    <span className="btn-icon" onClick={p=>props.onRemove(idx)}><img className="icon-small" src="img/icon/delete.svg" alt="icon pretrade"/></span>
                </li>
                ))}

            </ul>
        </div>
    )
}

export default PoliticalOfficerComp
